var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('formulario-cliente',{attrs:{"cliente":_vm.cliente,"imagenes":_vm.imagenes,"pais":_vm.pais,"contactos":_vm.contactos},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }